<div *ngIf="loaded">
    <mat-form-field>
        <mat-select placeholder="Raum wechseln" [formControl]="roomControl">
            <mat-option *ngFor="let room of location['rooms'];" [value]="room">
                {{ room['name'] }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>